import { useAtomValue, useSetAtom } from "jotai";
import { useCallback } from "react";
import { widgetMenuOptionsAtom, widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import { applyValue, setNewOptions } from "../../lib";
import type { ActiveSubMenuState, SetActiveSubMenu } from "../../types";
import { SubMenu } from "../SubMenu/SubMenu";
import styles from "./ShapeMenu.module.css";
import { ShapeMenuContent } from "./ShapeMenuContent";

interface ShapeMenuProps {
    activeSubMenu: ActiveSubMenuState;
    setActiveSubMenu: SetActiveSubMenu;
}

export function ShapeMenu({ activeSubMenu, setActiveSubMenu }: ShapeMenuProps) {
    const options = useAtomValue(widgetMenuOptionsByNameAtom("shape"));
    const setWidgetMenuOptions = useSetAtom(widgetMenuOptionsAtom);

    const handleShapeButtonClick = useCallback(
        (value: string) => {
            const setNewShapeOptions = setNewOptions({ name: "shape", setWidgetMenuOptions });

            function handleClose() {
                setActiveSubMenu(null);
            }

            applyValue({ options, value, setNewOptions: setNewShapeOptions, handleClose });
        },
        [options, setWidgetMenuOptions, setActiveSubMenu],
    );

    return (
        <SubMenu padding={0} activeSubMenu={activeSubMenu} className={styles.submenu}>
            <ShapeMenuContent onShapeButtonClick={handleShapeButtonClick} />
        </SubMenu>
    );
}
